<template>
	<v-container class="my-9">
		<v-row class="mb-4">
			<v-col cols md="9">
				<h2 class="display-2">Reto de Altares</h2>
			</v-col>
			<v-col md="3">
				<v-btn-toggle dark class="float-right white--text">
					<v-btn
						dark
						x-large
						rounded
						color="verde"
						href="/vinculacion/concursos/altares/">
						<v-icon left>mdi-home</v-icon>
						inicio
					</v-btn>
					<v-btn
						dark
						x-large
						rounded
						color="verde"
						href="/vinculacion/concursos/altares/rme">
						<v-icon>mdi-chevron-left</v-icon>
						regresar
					</v-btn>
				</v-btn-toggle>
			</v-col>
			<v-col>
				<v-divider class="dorado" />
			</v-col>
		</v-row>

		<v-row>
			<v-col md="7" sm="6">
				<v-img
					:src="
						getAltar.photoCompletion
							? getAltar.photoCompletion[0].content
							: 'https://cdn.vuetifyjs.com/images/parallax/material2.jpg'
					"
					class="elevation-4" />
			</v-col>
			<v-col md="5" sm="6">
				<h3
					class="blue-grey--text text--darken-4 text-h3 font-weight-bold mb-4">
					{{ getAltar.author ? getAltar.author.rme : getAltar.fullName }}
				</h3>
				<small class="text-uppercase blue-grey--text">Autor</small>
				<p
					class="blue-grey--text text--darken-3 text-h6 font-weight-medium text-uppercase">
					{{ getAltar.fullName }}
				</p>

				<small class="text-uppercase blue-grey--text">folio</small>
				<p class="blue-grey--text text--darken-2 text-uppercase">
					{{ getAltar.uuid }}
				</p>

				<small class="text-uppercase blue-grey--text">
					Votar por este altar
				</small>
				<p>
					<v-btn
						v-if="auth_status.loggedIn"
						x-large
						dark
						rounded
						class="rojo ma-2"
						@click="voto(getAltar.id, getAltar.uuid)">
						<v-icon left> mdi-thumb-up </v-icon>
						Me Gusta&nbsp;
						<v-btn fab class="mr-n6 dorado font-weight-bold">
							{{ !getAltar.rme_votes ? 0 : getAltar.rme_votes.length }}
						</v-btn>
					</v-btn>
					<v-btn
						x-large
						dark
						rounded
						color="#3b5998"
						class="ma-2"
						:href="`https://www.facebook.com/sharer/sharer.php?u=${selfPage}&amp;src=sdkpreparse`"
						target="_blank">
						<v-icon left> mdi-facebook </v-icon>
						Compartir
					</v-btn>
				</p>

				<v-row v-if="!auth_status.loggedIn">
					<v-col class="text-center mt-8">
						<h3 class="text-h6">Registrate o inicia sesión para participar</h3>
						<v-btn
							dark
							rounded
							color="dorado"
							class="my-4 mx-2"
							to="/auth/register">
							<v-icon left>mdi-import</v-icon>
							Registrarme
						</v-btn>
						<v-btn
							dark
							rounded
							color="dorado"
							class="my-4 mx-2"
							to="/auth/login">
							<v-icon left>mdi-account</v-icon>
							Iniciar sesion
						</v-btn>
					</v-col>
				</v-row>

				<div class="errors" v-if="currentVote.error">
					<v-alert
						v-if="currentVote.error.message === 'This attribute must be unique'"
						border="left"
						type="error"
						icon="mdi-alert">
						<strong>Ya has emitido tu voto en esta categoría.</strong>
					</v-alert>
				</div>
			</v-col>
		</v-row>

		<v-row>
			<v-col>
				<small class="text-uppercase blue-grey--text"> descripción </small>
				<p class="text-h6 font-weight-light mt-2">
					{{ getAltar.description }}
				</p>
			</v-col>
		</v-row>

		<!-- <pre>
            {{ getAltar }}
        </pre
		> -->

		<v-row>
			<v-col>
				<SeoComponent
					:seoTitle="`${getAltar.fullName} | ${getAltar.author.rme} | Representaciones | Reto de Altares `"
					:seoDescription="`${getAltar.description}`"
					:seoCanonical="selfPage"
					:seoImage="`${getAltar.photoCompletion[0].content}`" />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import wsMyIp from "@/services/api-my-ip";
	import wsAltarChallenge from "@/services/altares/api-altar-challenge";
	import wsAltarChallengeVotes from "@/services/altares/api-votes";
	import wsAltarChallengeVotesCount from "@/services/altares/api-votes-count";
	import SeoComponent from "@/components/global/Seo.vue";

	import { from } from "env-var"; // logger
	const env = from(process.env, {});
	const COOKIE_TIME = env.get("VUE_APP_COOKIE").required().asString();

	export default {
		name: "AltarsUuidView",

		components: { SeoComponent },

		data: () => ({
			myIp: {},
			currentVote: {},
			getAllVotes: {},
			getAltar: {
				photoCompletion: [0],
				community_votes: [],
				rme_votes: [],
				author: {},
			},
		}),

		computed: {
			setUuid() {
				var cookie = this.dataCookie[2];
				return cookie;
			},
			readCookie() {
				let cookie = this.$cookies.isKey("__imme_reto_de_altares__");
				return cookie;
			},
			selfUuid() {
				let page = this.$route.params.uuid;
				return page;
			},

			selfPage() {
				let self = process.env.VUE_APP_BASE_URL + this.$route.path;
				return self;
			},

			auth_status() {
				return this.$store.state.auth.status;
			},

			auth_user() {
				return this.$store.state.auth.user.user;
			},

			verify_jwt() {
				let token = this.$localStorage.get("user");
				let jwt = JSON.parse(token);
				return jwt;
			},
		},

		mounted() {
			// this.loadAltars(
			// 	"comunidad_mx",
			// 	18,
			// 	!this.thisPagination ? this.thisPagination.page : 1
			// );
			this.loadAltars(this.selfUuid);
			//this.loadVotes(this.selfUuid);
			this.loadIpClient();
		},

		methods: {
			track() {
				this.$gtag.event(click, {
					event_category: "event_name",
					event_label: "uuid-folio",
					value: this.selfUuid,
				});
			},

			loadAltars(uuid) {
				wsAltarChallenge.getAltar(uuid).then(
					(response) => {
						this.getAltar = response.data.data[0];
					},
					(error) => {
						this.getAltar =
							(error.response && error.response) ||
							error.message ||
							error.toString();
					}
				);
			},

			loadVotes(uuid) {
				wsAltarChallengeVotesCount.countVoteRme(uuid).then(
					(response) => {
						this.getAllVotes = response.data.data;
						//let getVotes = response.data.data;
						//console.log("🚀 ~ loadVotes ~ getVotes:", getVotes);
					},
					(error) => {
						this.getAllVotes =
							(error.response && error.response) ||
							error.message ||
							error.toString();
					}
				);
			},

			thumb_convert(src) {
				let image = src.replaceAll("/thumbnail_ALTARES_2024", "/ALTARES_2024");
				return image;
			},

			voto(altarId, uuid) {
				let geodata = {
					ip: this.myIp.ip,
					city: this.myIp.city,
					region: this.myIp.region,
					country: this.myIp.country,
					timezone: this.myIp.timezone,
				};

				let dataVote = {
					validate: true,
					sso: true,
					metadata: geodata,
					whoisIp: geodata.ip,
					userUuid: this.auth_user.id,
					altar_challenge: altarId,
					author: this.auth_user.id,
				};

				wsAltarChallengeVotes.createVoteRme({ data: dataVote }).then(
					(response) => {
						this.currentVote = response.data.data;
						//let voteId = this.currentVote.id;

						this.$cookies.set(
							"__imme_reto_de_altares__",
							`${this.auth_user.id}.${this.auth_user.email}.${geodata.ip}`,
							COOKIE_TIME
						);
						this.loadAltars(uuid);
						//this.votoAltar(altarId, voteId, uuid);
						//console.log("🚀 ~ voto ~ voteId:", voteId);
						console.log("✔✔✔");
					},
					(error) => {
						this.currentVote =
							(error.response && error.response.data) ||
							error.message ||
							error.toString();
					}
				);
			},

			votoAltar(altarId, voteId, uuid) {
				let data = {
					community_votes: voteId,
				};
				wsAltarChallenge.voteAltar(altarId, { data }).then(
					(response) => {
						//console.log("🚀 ~ votoAltar ~ response:", response);
						this.loadVotes(uuid);
						console.log("✔");
					},
					(error) => {
						this.currentVote =
							(error.response && error.response.data) ||
							error.message ||
							error.toString();
					}
				);
			},

			loadIpClient() {
				wsMyIp.getMyIp().then(
					(response) => {
						this.myIp = response.data;
						// console.log("🚀 ~ loadIpClient ~ this.myIp:", this.myIp);
						// console.log("✔✔");
					},
					(error) => {
						this.myIp =
							(error.response && error.response.data) ||
							error.message ||
							error.toString();
					}
				);
			},
		},
	};
</script>
